import { fmt } from "../../utils";

function parseDate(val) {
  if (!val) return "-";
  try {
    const d = val.seconds ? new Date(val.seconds * 1000) : new Date(val);
    return isNaN(d) ? "-" : d.toLocaleDateString("fr-FR");
  } catch {
    return "-";
  }
}

export default function HistoriqueDedouanement({ rows, monthRange }) {
  const mois = monthRange?.start?.toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  return (
    <div className="card" style={{ marginBottom: 14 }}>
      <div className="card-header">
        <span className="card-title">
          📋 Historique dédouanements{mois ? ` — ${mois}` : ""} ({rows.length})
        </span>
      </div>

      {rows.length === 0 ? (
        <div style={{ padding: 20, textAlign: "center", color: "var(--muted)" }}>
          Aucun dédouanement{mois ? ` en ${mois}` : " enregistré"}
        </div>
      ) : (
        <div style={{ padding: 0 }}>
          {rows.map((d, i) => (
            <div
              key={d.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 14px",
                borderBottom: i < rows.length - 1 ? "1px solid var(--border)" : "none",
              }}
            >
              <div>
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: 11,
                    fontWeight: 600,
                    color: "var(--text)",
                  }}
                >
                  {d.reference || d.lotRef}
                </div>
                <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}>
                  {d.lotRef !== (d.reference || d.lotRef) ? d.lotRef + " · " : ""}
                  {parseDate(d.date || d.createdAt)}
                </div>
              </div>
              <div
                style={{
                  fontFamily: "var(--font-mono)",
                  fontSize: 14,
                  fontWeight: 700,
                  color: "var(--green)",
                }}
              >
                {fmt(d.volumeM3)} m³
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
